module.exports = __webpack_public_path__ + "img/jar.64066df0.svg";